<template>
   <Row>
        <i-col span="12">
    <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">
         <FormItem label="支付方式代码" prop="code">
           <span>{{formValidate.code}}</span>
            <!-- <i-input v-model="formValidate.code" placeholder="请输入支付方式代码"></i-input> -->
        </FormItem>
       <FormItem label="支付方式名称" prop="name">
            <i-input v-model="formValidate.name" placeholder="请输入支付方式名称"></i-input>
        </FormItem>
     
        <template v-if="formValidate.code=='wechat'">
      <FormItem label="公众号APPID" prop="appid">
            <!-- <textarea class="paydata"></textarea> -->
            <i-input v-model="formValidate.appid" type="text" :autosize="true" placeholder="请输入公众号APPID"></i-input>
            <!-- <i-input v-model="formValidate.data" placeholder="请输入额外参数"></i-input> -->
        </FormItem>
         <FormItem label="服务商户号" prop="mch_id">
            <!-- <textarea class="paydata"></textarea> -->
            <i-input v-model="formValidate.mch_id" type="text" :autosize="true" placeholder="请输入服务商户号"></i-input>
            <!-- <i-input v-model="formValidate.data" placeholder="请输入额外参数"></i-input> -->
        </FormItem>
        <FormItem label="交易密钥" prop="key">
            <!-- <textarea class="paydata"></textarea> -->
            <i-input v-model="formValidate.key" type="text" :autosize="true" placeholder="请输入交易密钥"></i-input>
            <!-- <i-input v-model="formValidate.data" placeholder="请输入额外参数"></i-input> -->
        </FormItem>
        </template>
     <FormItem label="额外参数" prop="data" v-else>
            <!-- <textarea class="paydata"></textarea> -->
            <i-input v-model="formValidate.data" type="textarea" :autosize="true" placeholder="请输入额外参数"></i-input>
            <!-- <i-input v-model="formValidate.data" placeholder="请输入额外参数"></i-input> -->
        </FormItem>
        
        <FormItem label="是否启用" prop="isvalid">
                <RadioGroup v-model="formValidate.isvalid">
                    <Radio label="1">开启</Radio>
                    <Radio label="0">关闭</Radio>
                </RadioGroup>
        </FormItem> 
        <FormItem label="排序" prop="sort">
            <i-input v-model="formValidate.sort"></i-input>
        </FormItem>
        <FormItem>
            <Button type="primary" @click="handleSubmit1('formValidate')">提交</Button>
        </FormItem>
    </Form>
     </i-col>
        <i-col span="12"></i-col>
    </Row>
</template>
<script>
import { paymethodupdate } from "../../api/paymethodapi";
import format from "../../constant/Json.js";
export default {
  data() {
    return {
      formValidate: {
        code: "",
        name: "",
        appid: "",
        mch_id: "",
        data:"",
        key: "",
        isvalid: "1",
        sort: ""
      },
      ruleValidate: {
        name: [
          { required: true, message: "请输入支付方式名称", trigger: "blur" }
        ],
        code: [
          { required: true, message: "请输入支付方式代码", trigger: "blur" }
        ],
        appid: [
          { required: true, message: "请输入公众号APPID", trigger: "blur" }
        ],
        mch_id: [
          { required: true, message: "请输入服务商户号", trigger: "blur" }
        ],
        key: [{ required: true, message: "请输入交易密钥", trigger: "blur" }]
      }
    };
  },
  methods: {
    handleSubmit1(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.paymethodupdate();
        } else {
          this.$Message.error("请检查输入");
        }
      });
    },
    sreplace(str) {
      var whitespace =
        " \n\r\t\f\x0b\xa0\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u200b\u2028\u2029\u3000";
      for (var i = 0, len = str.length; i < len; i++) {
        if (whitespace.indexOf(str.charAt(i)) === -1) {
          str = str.substring(i);
          break;
        }
      }
      for (i = str.length - 1; i >= 0; i--) {
        if (whitespace.indexOf(str.charAt(i)) === -1) {
          str = str.substring(0, i + 1);
          break;
        }
      }
      return whitespace.indexOf(str.charAt(0)) === -1 ? str : "";
    },
    paymethodupdate() {
      var par = this.formValidate;
    if(par.code=='wechat'){
        par.data = {
        appid: this.formValidate.appid,
        mch_id: this.formValidate.mch_id,
        key: this.formValidate.key
        
      };
       par.data = JSON.stringify(par.data);
      }else{
      par.data = this.formValidate.data.replace(/[\r\n]/g, "");
      par.data=this.sreplace(par.data)
      par.data=par.data.toString()
      }
      paymethodupdate(par).then(res => {
        let data = res.data;
        if (data.code == 1) {
          this.$Message.success(data.message);
          this.$router.push({ path: "paymethodindex" });
        } else {
          this.$Message.error(data.message);
        }
      });
    }
  },
  mounted() {
    if (this.$route && this.$route.query) {
      this.formValidate = this.$route.query;
      if(this.formValidate.code=="wechat"){
      var data = JSON.parse(this.$route.query.data);
      if (data && data.appid && data.key && data.mch_id) {
        this.formValidate.appid = data.appid;
        this.formValidate.key = data.key;
        this.formValidate.mch_id = data.mch_id;
      }
      }else{
              this.formValidate.data = format(this.$route.query.data); 
      }


      //  this.formValidate.data=this.formValidate.data.replace(/<br\/>/g,"\n").replace(/\&nbsp\;/g," ");
      //   $(".paydata").val(this.formValidate.data)
      this.formValidate.isvalid = this.formValidate.isvalid + "";
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/System/paymethodupdate.vue